import React from 'react';
import {NumericFormat} from 'react-number-format';
import styles from './Input.module.css';

const Input = ({
  label,
  type = 'text',
  value,
  onChange,
  placeholder,
  error,
  required = false,
  disabled = false,
  ...props
}) => {
  const inputId = `input-${Math.random().toString(36).substr(2, 9)}`;

  if (type === 'currency') {
    return (
      <div className={styles.inputGroup}>
        {label && (
          <label htmlFor={inputId} className={styles.label}>
            {label} {required && <span className={styles.required}>*</span>}
          </label>
        )}
        <NumericFormat
          id={inputId}
          className={`${styles.input} ${error ? styles.error : ''}`}
          thousandSeparator="."
          decimalSeparator=","
          prefix="Rp "
          value={value}
          onValueChange={(values) => onChange(values.floatValue)}
          placeholder={placeholder}
          disabled={disabled}
          {...props}
        />
        {error && <span className={styles.errorMessage}>{error}</span>}
      </div>
    );
  }

  return (
    <div className={styles.inputGroup}>
      {label && (
        <label htmlFor={inputId} className={styles.label}>
          {label} {required && <span className={styles.required}>*</span>}
        </label>
      )}
      <input
        id={inputId}
        type={type}
        className={`${styles.input} ${error ? styles.error : ''}`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        {...props}
      />
      {error && <span className={styles.errorMessage}>{error}</span>}
    </div>
  );
};

export default Input;